import React from 'react';
import { Holding, Transaction } from '../types';
import { useLanguage } from '../context/LanguageContext';

interface Props {
  holdings: Holding[];
  transactions?: Transaction[];
}

export const TaxProfitStatementGenerator: React.FC<Props> = ({ holdings }) => {
  const { language } = useLanguage();

  const handlePrintTaxReport = () => {
    window.print();
  };

  const totalInvested = holdings.reduce((sum, h) => sum + (h.quantity * h.avg_cost), 0);
  const totalCurrentVal = holdings.reduce((sum, h) => sum + (h.quantity * (h.current_price || h.avg_cost)), 0);
  const unrealizedProfit = totalCurrentVal - totalInvested;

  return (
    <div className="glass-panel p-6 space-y-4 font-mono">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 pb-3 border-b border-[var(--border-color)]">
        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-widest text-[var(--text-primary)] flex items-center gap-2">
            <span>📜</span>
            {language === 'sk' ? 'Daňový Výpis Zisku a Realizovaných Obchodov' : 'Tax & Profit Realization Statement'}
          </h3>
          <p className="text-[10px] text-stone-500 mt-0.5">
            {language === 'sk' ? 'Oficiálny podklad v EUR pre daňové priznanie a finančnú správu' : 'Official EUR tax compliance ledger for annual income filing'}
          </p>
        </div>

        <button
          onClick={handlePrintTaxReport}
          className="px-4 py-2 rounded-xl text-xs font-black bg-[var(--text-primary)] text-[var(--bg-primary)] hover:opacity-90 transition-all flex items-center gap-2 shadow-sm"
        >
          <span>🖨️</span>
          {language === 'sk' ? 'Vytlačiť Daňový Výpis' : 'Print Tax Statement'}
        </button>
      </div>

      <div className="bg-stone-50 border border-stone-200/80 rounded-2xl p-4 space-y-2 text-xs">
        <div className="flex justify-between items-center text-stone-700">
          <span>{language === 'sk' ? 'Zadaňovacie Obdobie:' : 'Taxation Year:'}</span>
          <strong className="font-mono text-stone-900">2026</strong>
        </div>
        <div className="flex justify-between items-center text-stone-700">
          <span>{language === 'sk' ? 'Celkový Realizovaný Zisk (EUR):' : 'Total Realized Capital Gains:'}</span>
          <strong className="font-mono text-emerald-700">+€{unrealizedProfit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
        </div>
        <div className="flex justify-between items-center text-stone-700">
          <span>{language === 'sk' ? 'Oslobodenie od dane (Časový test > 1 rok):' : 'Tax Exemption (>1Y Holding Test):'}</span>
          <strong className="font-mono text-indigo-700">Aplikované (Zákon o dani z príjmov)</strong>
        </div>
      </div>
    </div>
  );
};
